import React from 'react';
import s from './Inp.module.css';
export function Field({label,hint,required,children}){
  return(<div className={s.f}>
    {label&&<label className={s.lb}>{label}{required&&<span className={s.req}> *</span>}{hint&&<span className={s.ht}> — {hint}</span>}</label>}
    {children}
  </div>);
}
export function Inp({type='text',value,onChange,placeholder,required,autoComplete,autoFocus,maxLength,inputMode,style,className}){
  return<input className={`${s.i} ${className||''}`} type={type} value={value} onChange={onChange} placeholder={placeholder} required={required} autoComplete={autoComplete} autoFocus={autoFocus} maxLength={maxLength} inputMode={inputMode} style={style}/>;
}
export function Sel({value,onChange,children}){return<select className={s.i} value={value} onChange={onChange}>{children}</select>;}
